import { type LoaderFunctionArgs, type MetaFunction } from '@remix-run/node'
import { Link, redirect } from '@remix-run/react'

import { getUserId } from '#app/utils/auth.server'

export const meta: MetaFunction = () => [{ title: 'In Touch' }]

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const userId = await getUserId(request)
	if (userId) {
		throw redirect('/contacts')
	}

	return {}
}

export default function Index() {
	return (
		<main className="font-poppins grid h-full place-items-center">
			<div className="grid place-items-center px-4 py-16 xl:grid-cols-2 xl:gap-24">
				<div className="flex max-w-md flex-col items-center text-center xl:order-2 xl:items-start xl:text-left">
					<h1
						data-heading
						className="animate-slide-top text-foreground xl:animate-slide-left mt-8 text-4xl font-medium [animation-delay:0.2s] [animation-fill-mode:backwards] md:text-5xl xl:mt-4 xl:text-6xl xl:[animation-delay:0.8s] xl:[animation-fill-mode:backwards]"
					>
						In Touch
					</h1>
					<p
						data-paragraph
						className="animate-slide-top text-muted-foreground xl:animate-slide-left mt-6 text-xl/7 [animation-delay:0.8s] [animation-fill-mode:backwards] xl:mt-8 xl:text-xl/6 xl:leading-10 xl:[animation-delay:1s] xl:[animation-fill-mode:backwards]"
					>
						Check{' '}
						<Link
							className="underline hover:no-underline"
							to="contacts"
							prefetch="intent"
						>
							my contacts
						</Link>{' '}
						to start managing your network!
					</p>
				</div>
			</div>
		</main>
	)
}
